import { SET_PRODUCT_PARAMS } from './../const';

export default (params) => {
    return {type: SET_PRODUCT_PARAMS, params}
};
